import { GameSettingType } from "@1games-ru/region-shared/dist/enums/account/settings";
import { useMemo } from "react";

export default function useSoundValues() {
  const soundValues = useMemo(
    () => [
      GameSettingType.SettingOverallVolume,
      GameSettingType.SettingEnvironmentVolume,
      GameSettingType.SettingVoiceChatAndPhoneVolume,
      GameSettingType.SettingInterfaceSoundsVolume,
      GameSettingType.SettingCaseOpeningVolume,
      GameSettingType.SettingMenuInterfaceMusicVolume,
      GameSettingType.SettingInGameMusicVolume,
      GameSettingType.SettingRadioVolume,
    ],
    [],
  );

  return { soundValues };
}
